import React from 'react';
import { useTranslation } from 'react-i18next';
import commonStyles from './style/endResultStageCommon.module.scss';

interface IProps {
  bankName: string;
  companyName: string;
  extendedConsentEnd?: Date;
}

const BankUpdated: React.FC<IProps> = ({ bankName, companyName, extendedConsentEnd }: IProps) => {
  const { t } = useTranslation();
  return (
    <div className={`text-left text-primary-2`} data-testid="bank-updated-screen">
      <div className="flex flex-col sm:flex-row mb-2 sm:mb-0">
        <h1 className="uppercase text-md font-semi-bold">{t('Access updated')}</h1>
      </div>
      <div className="mt-2" data-testid="bank-updated-screen-content">
        {extendedConsentEnd
          ? t<string>('Access to your {{bankName}} account data has been updated.', {
              bankName: bankName
            })
          : t<string>('Your {{bankName}} account data has been successfully reconnected.', {
              bankName: bankName
            })}
      </div>
      {!extendedConsentEnd || (
        <div className={commonStyles.content}>
          {t<string>('{{companyName}} will now be able to access data until the following date:', {
            companyName: companyName
          })}
          <span className={`${commonStyles.dateContent} ml-2 font-semi-bold`}>
            {extendedConsentEnd.toLocaleDateString(navigator.language, {
              year: 'numeric',
              month: 'long',
              day: '2-digit'
            })}
          </span>
        </div>
      )}
    </div>
  );
};

export default BankUpdated;
